import axios from 'axios';

export default function extractApiError(err: unknown): string {
  if (axios.isAxiosError(err) && err.response?.data) {
    const data = err.response.data;
    if (typeof data.detail === 'string') return data.detail;
    if (typeof data === 'object' && data !== null) {
      return Object.entries(data)
        .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : val}`)
        .join('; ');
    }
  }
  return err instanceof Error ? err.message : 'An unexpected error occurred';
}
